// extracted by mini-css-extract-plugin
export var marginNegative = "_5a-5 _5a-3 _5a-1";
export var marginPositive = "_5a-4 _5a-3 _5a-1";
export var modalContent = "_5a-6";
export var samplesTable = "_5a-8";
export var samplesTableContainer = "_5a-7";
export var statBox = "_5a-a";
export var tableCell = "_5a-1";
export var tableCellCenter = "_5a-2 _5a-1";
export var tableCellRight = "_5a-3 _5a-1";
export var tableHeader = "_5a-0";
export var trackingNumber = "_5a-9";